import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import LocationCreate from "pages/inventory/location/LocationCreate";
import LocationList from "pages/inventory/location/LocationList";
import React from "react";
import { FaMapMarkedAlt } from "react-icons/fa";
import { RiMapPinAddLine } from "react-icons/ri";

const LocationManagement = () => {
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Kitchen"
        viewIcon={<FaMapMarkedAlt />}
        createIcon={<RiMapPinAddLine />}
        createChildren={<LocationCreate />}
        listChildren={<LocationList />}
      />
    </Box>
  );
};

export default LocationManagement;
